import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "validationerror--message"
}
const _hoisted_2 = {
  key: 1,
  class: "validationerror--message"
}
const _hoisted_3 = {
  key: 2,
  class: "validationerror--message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.errorMessage && !_ctx.errorMessageParam)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t(`error.${_ctx.errorMessage}`)), 1))
      : _createCommentVNode("", true),
    (_ctx.errorMessage && _ctx.errorMessageParam && _ctx.errorMessageKey === 'min' || _ctx.errorMessageKey === 'minLength')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t(`error.${_ctx.errorMessageKey}`, {min: _ctx.errorMessageParam})), 1))
      : _createCommentVNode("", true),
    (_ctx.errorMessage && _ctx.errorMessageParam && _ctx.errorMessageKey === 'max' || _ctx.errorMessageKey === 'maxLength')
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t(`error.${_ctx.errorMessageKey}`, {max: _ctx.errorMessageParam})), 1))
      : _createCommentVNode("", true)
  ], 64))
}